// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./fonts/glucose-icons/export/Glucose-Icons.woff2");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./fonts/glucose-icons/export/Glucose-Icons.woff");
var ___CSS_LOADER_URL_IMPORT_2___ = require("./fonts/glucose-icons/export/Horizon-Icons.woff2");
var ___CSS_LOADER_URL_IMPORT_3___ = require("./fonts/glucose-icons/export/Horizon-Icons.woff");
var ___CSS_LOADER_URL_IMPORT_4___ = require("./fonts/open-sans/open-sans-v17-latin-regular.woff2");
var ___CSS_LOADER_URL_IMPORT_5___ = require("./fonts/open-sans/open-sans-v17-latin-regular.woff");
var ___CSS_LOADER_URL_IMPORT_6___ = require("./fonts/open-sans/open-sans-v17-latin-italic.woff2");
var ___CSS_LOADER_URL_IMPORT_7___ = require("./fonts/open-sans/open-sans-v17-latin-italic.woff");
var ___CSS_LOADER_URL_IMPORT_8___ = require("./fonts/open-sans/open-sans-v17-latin-600.woff2");
var ___CSS_LOADER_URL_IMPORT_9___ = require("./fonts/open-sans/open-sans-v17-latin-600.woff");
var ___CSS_LOADER_URL_IMPORT_10___ = require("./fonts/roboto-mono/roboto-mono-v5-latin-regular.woff2");
var ___CSS_LOADER_URL_IMPORT_11___ = require("./fonts/roboto-mono/roboto-mono-v5-latin-regular.woff");
var ___CSS_LOADER_URL_IMPORT_12___ = require("./fonts/72/72-Regular.woff2");
var ___CSS_LOADER_URL_IMPORT_13___ = require("./fonts/72/72-Regular.woff");
var ___CSS_LOADER_URL_IMPORT_14___ = require("./fonts/72/72-Bold.woff2");
var ___CSS_LOADER_URL_IMPORT_15___ = require("./fonts/72/72-Regular-full.woff2");
var ___CSS_LOADER_URL_IMPORT_16___ = require("./fonts/72/72-Regular-full.woff");
var ___CSS_LOADER_URL_IMPORT_17___ = require("./fonts/72/72-Bold-full.woff2");
var ___CSS_LOADER_URL_IMPORT_18___ = require("./fonts/72/72-Bold-full.woff");
var ___CSS_LOADER_URL_IMPORT_19___ = require("./fonts/72/72Mono-Regular.woff2");
var ___CSS_LOADER_URL_IMPORT_20___ = require("./fonts/72/72Mono-Regular.woff");
var ___CSS_LOADER_URL_IMPORT_21___ = require("./fonts/72/72Mono-Regular-full.woff2");
var ___CSS_LOADER_URL_IMPORT_22___ = require("./fonts/72/72Mono-Regular-full.woff");
var ___CSS_LOADER_URL_IMPORT_23___ = require("./fonts/72/72-Black.woff2");
var ___CSS_LOADER_URL_IMPORT_24___ = require("./fonts/72/72-Black.woff");
var ___CSS_LOADER_URL_IMPORT_25___ = require("./fonts/72/72-Black-full.woff2");
var ___CSS_LOADER_URL_IMPORT_26___ = require("./fonts/72/72-Black-full.woff");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* signavio-application-icons */
@font-face {
  font-family: 'Glucose-Icons';
  font-style: normal;
  font-weight: normal;
  unicode-range: U+20,U+e000-fffd;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

@font-face {
  font-family: 'Horizon-Icons';
  font-style: normal;
  font-weight: normal;
  unicode-range: U+20,U+e000-fffd;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}

/* open-sans-regular - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: local('Open Sans Regular'), local('OpenSans-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}
/* open-sans-italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 400;
  src: local('Open Sans Italic'), local('OpenSans-Italic'),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}
/* open-sans-600 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
}

/* roboto-mono-regular - latin */
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 400;
  src: local('Roboto Mono'), local('RobotoMono-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
}

/* 72 */
@font-face {
  font-family: '72';
  font-style: normal;
  font-weight: 400;
  font-display: optional;
  src: local('72'), local('72-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
}

/* 72-Bold */
@font-face {
  font-family: '72';
  font-style: normal;
  font-weight: 700;
  font-display: optional;
  src: local('72 Bold'), local('72-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
}

/* 72-Full */
@font-face {
  font-family: '72full';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local('72'), local('72-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff');
}

/* 72-Full Bold */
@font-face {
  font-family: '72full';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local('72 Bold'), local('72-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff');
}

/* 72-Mono */
@font-face {
  font-family: '72Mono';
  font-style: normal;
  font-weight: 400;
  font-display: optional;
  src: local('72 Mono'), local('72Mono-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff');
}

/* 72-Mono-Full */
@font-face {
  font-family: '72Monofull';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local('72 Mono'), local('72Mono-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff');
}

/* 72-Black */
@font-face {
  font-family: '72Black';
  font-style: bold;
  font-weight: 900;
  font-display: swap;
  src: local('72 Black'), local('72Black')
    url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('woff');
}

/* 72-Black Full */
@font-face {
  font-family: '72Blackfull';
  font-style: bold;
  font-weight: 900;
  font-display: swap;
  src: local('72 Black'), local('72Black')
    url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff');
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@signavio/ui/assets/fonts.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B;0DACqE;AACvE;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B;0DACqE;AACvE;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB;;0DAEwE;AAC1E;AACA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB;;0DAEuE;AACzE;AACA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB;;0DAEoE;AACtE;;AAEA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;;2DAE2E;AAC7E;;AAEA,OAAO;AACP;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB;;2DAEgD;AAClD;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB;;2DAEgD;AAClD;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEkD;AACpD;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB;;2DAEoD;AACtD;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEyD;AAC3D;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAE8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB;;2DAEmD;AACrD","sourcesContent":["/* signavio-application-icons */\n@font-face {\n  font-family: 'Glucose-Icons';\n  font-style: normal;\n  font-weight: normal;\n  unicode-range: U+20,U+e000-fffd;\n  src: url('fonts/glucose-icons/export/Glucose-Icons.woff2') format('woff2'),\n    url('fonts/glucose-icons/export/Glucose-Icons.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Horizon-Icons';\n  font-style: normal;\n  font-weight: normal;\n  unicode-range: U+20,U+e000-fffd;\n  src: url('fonts/glucose-icons/export/Horizon-Icons.woff2') format('woff2'),\n    url('fonts/glucose-icons/export/Horizon-Icons.woff') format('woff');\n}\n\n/* open-sans-regular - latin */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'),\n    url('fonts/open-sans/open-sans-v17-latin-regular.woff2') format('woff2'),\n    url('fonts/open-sans/open-sans-v17-latin-regular.woff') format('woff');\n}\n/* open-sans-italic - latin */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: local('Open Sans Italic'), local('OpenSans-Italic'),\n    url('fonts/open-sans/open-sans-v17-latin-italic.woff2') format('woff2'),\n    url('fonts/open-sans/open-sans-v17-latin-italic.woff') format('woff');\n}\n/* open-sans-600 - latin */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'),\n    url('fonts/open-sans/open-sans-v17-latin-600.woff2') format('woff2'),\n    url('fonts/open-sans/open-sans-v17-latin-600.woff') format('woff');\n}\n\n/* roboto-mono-regular - latin */\n@font-face {\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Roboto Mono'), local('RobotoMono-Regular'),\n    url('fonts/roboto-mono/roboto-mono-v5-latin-regular.woff2') format('woff2'),\n    url('fonts/roboto-mono/roboto-mono-v5-latin-regular.woff') format('woff');\n}\n\n/* 72 */\n@font-face {\n  font-family: '72';\n  font-style: normal;\n  font-weight: 400;\n  font-display: optional;\n  src: local('72'), local('72-Regular'),\n    url('fonts/72/72-Regular.woff2') format('woff2'),\n    url('fonts/72/72-Regular.woff') format('woff');\n}\n\n/* 72-Bold */\n@font-face {\n  font-family: '72';\n  font-style: normal;\n  font-weight: 700;\n  font-display: optional;\n  src: local('72 Bold'), local('72-Bold'),\n    url('fonts/72/72-Bold.woff2') format('woff2'),\n    url('fonts/72/72-Regular.woff') format('woff');\n}\n\n/* 72-Full */\n@font-face {\n  font-family: '72full';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: local('72'), local('72-Regular'),\n    url('fonts/72/72-Regular-full.woff2') format('woff2'),\n    url('fonts/72/72-Regular-full.woff') format('woff');\n}\n\n/* 72-Full Bold */\n@font-face {\n  font-family: '72full';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: local('72 Bold'), local('72-Bold'),\n    url('fonts/72/72-Bold-full.woff2') format('woff2'),\n    url('fonts/72/72-Bold-full.woff') format('woff');\n}\n\n/* 72-Mono */\n@font-face {\n  font-family: '72Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-display: optional;\n  src: local('72 Mono'), local('72Mono-Regular'),\n    url('fonts/72/72Mono-Regular.woff2') format('woff2'),\n    url('fonts/72/72Mono-Regular.woff') format('woff');\n}\n\n/* 72-Mono-Full */\n@font-face {\n  font-family: '72Monofull';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: local('72 Mono'), local('72Mono-Regular'),\n    url('fonts/72/72Mono-Regular-full.woff2') format('woff2'),\n    url('fonts/72/72Mono-Regular-full.woff') format('woff');\n}\n\n/* 72-Black */\n@font-face {\n  font-family: '72Black';\n  font-style: bold;\n  font-weight: 900;\n  font-display: swap;\n  src: local('72 Black'), local('72Black')\n    url('fonts/72/72-Black.woff2') format('woff2'),\n    url('fonts/72/72-Black.woff') format('woff');\n}\n\n/* 72-Black Full */\n@font-face {\n  font-family: '72Blackfull';\n  font-style: bold;\n  font-weight: 900;\n  font-display: swap;\n  src: local('72 Black'), local('72Black')\n    url('fonts/72/72-Black-full.woff2') format('woff2'),\n    url('fonts/72/72-Black-full.woff') format('woff');\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
